<div class="container-fluid">
  <div class="row">
    @for (Contact of Contacts; track Contact; let index = $index) {
      <div class="col-4 pt-2">
        <app-display-card [innerPanel]="true">
          <div class="row">
            <div class="col">
              <label>First Name:</label>
            </div>
            <div class="col">
              <label class="fw-normal">{{ Contact.firstName }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label>Last Name:</label>
            </div>
            <div class="col">
              <label class="fw-normal">{{ Contact.lastName }}</label>
            </div>
          </div>
          @if (Contact.jobTitle) {
            <div class="row">
              <div class="col">
                <label>Job Title:</label>
              </div>
              <div class="col">
                <label class="fw-normal">{{ Contact.jobTitle }}</label>
              </div>
            </div>
          }
          @if (Contact.email) {
            <div class="row">
              <div class="col">
                <label>Email:</label>
              </div>
              <div class="col">
                <app-email-container
                  [email]="Contact.email"
                ></app-email-container>
              </div>
            </div>
          }
          <div class="row">
            <div class="col">
              <label>Phone Number:</label>
            </div>
            <div class="col">
              <label class="fw-normal">{{ Contact.phone1 }}</label>
            </div>
          </div>
          @if (Contact.ext) {
            <div class="row">
              <div class="col">
                <label>Ext:</label>
              </div>
              <div class="col">
                <label class="fw-normal">{{ Contact.ext }}</label>
              </div>
            </div>
          }
          <div class="row">
            <div class="col-6">
              <button
                class="btn btn-danger"
                (click)="deleteContact(Contact, index)"
              >
                Delete
              </button>
            </div>
          </div>
        </app-display-card>
      </div>
    }
  </div>
</div>
